export const InsufficientFeedbackForSummaryIcon = () => {
  return (
    <svg width="61" height="46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.333 12.332H4.66634C3.38301 12.332 2.34467 13.382 2.34467 14.6654L2.33301 35.6654L6.99967 30.9987H23.333C24.6163 30.9987 25.6663 29.9487 25.6663 28.6654V14.6654C25.6663 13.382 24.6163 12.332 23.333 12.332ZM8.16634 20.4987H19.833C20.4747 20.4987 20.9997 21.0237 20.9997 21.6654C20.9997 22.307 20.4747 22.832 19.833 22.832H8.16634C7.52467 22.832 6.99967 22.307 6.99967 21.6654C6.99967 21.0237 7.52467 20.4987 8.16634 20.4987ZM15.1663 26.332H8.16634C7.52467 26.332 6.99967 25.807 6.99967 25.1654C6.99967 24.5237 7.52467 23.9987 8.16634 23.9987H15.1663C15.808 23.9987 16.333 24.5237 16.333 25.1654C16.333 25.807 15.808 26.332 15.1663 26.332ZM19.833 19.332H8.16634C7.52467 19.332 6.99967 18.807 6.99967 18.1654C6.99967 17.5237 7.52467 16.9987 8.16634 16.9987H19.833C20.4747 16.9987 20.9997 17.5237 20.9997 18.1654C20.9997 18.807 20.4747 19.332 19.833 19.332Z"
        fill="#661D93"
        fillOpacity="0.5"
      />
      <path
        d="M25.167 2.58203H45.8337C47.2545 2.58203 48.4041 3.74453 48.4041 5.16536L48.417 28.4154L43.2503 23.2487H25.167C23.7462 23.2487 22.5837 22.0862 22.5837 20.6654V5.16536C22.5837 3.74453 23.7462 2.58203 25.167 2.58203ZM41.9587 11.6237H29.042C28.3316 11.6237 27.7503 12.2049 27.7503 12.9154C27.7503 13.6258 28.3316 14.207 29.042 14.207H41.9587C42.6691 14.207 43.2503 13.6258 43.2503 12.9154C43.2503 12.2049 42.6691 11.6237 41.9587 11.6237ZM34.2087 18.082H41.9587C42.6691 18.082 43.2503 17.5008 43.2503 16.7904C43.2503 16.08 42.6691 15.4987 41.9587 15.4987H34.2087C33.4982 15.4987 32.917 16.08 32.917 16.7904C32.917 17.5008 33.4982 18.082 34.2087 18.082ZM29.042 10.332H41.9587C42.6691 10.332 43.2503 9.75078 43.2503 9.04037C43.2503 8.32995 42.6691 7.7487 41.9587 7.7487H29.042C28.3316 7.7487 27.7503 8.32995 27.7503 9.04037C27.7503 9.75078 28.3316 10.332 29.042 10.332Z"
        fill="#743C97"
        fillOpacity="0.5"
      />
      <circle
        cx="52.9998"
        cy="33.16"
        r="4.16"
        fill="#E8A625"
        fillOpacity="0.41"
      />
      <mask
        id="mask0_757_261837"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="45"
        y="37"
        width="16"
        height="9"
      >
        <rect x="45" y="37.9609" width="16" height="7.68" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_757_261837)">
        <circle
          cx="52.9996"
          cy="45.3209"
          r="7.36"
          fill="#E8A625"
          fillOpacity="0.41"
        />
      </g>
    </svg>
  );
};
